package org.example.site_web.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initLegalNoticePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("LegalNotice.md", FrontMatterElement.Builder { addScalar("title", "About"); }))
}

@Page("/legal-notice")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun LegalNoticePage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("mention-légales") }) {
        org.jetbrains.compose.web.dom.Text("Mention Légales")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Le site internet accelarge-innovations.com est édité par la société ACCELARGE INNOVATIONS SAS dont le siège social est situé :")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("ESPACE CREA")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("PARC TECHNOLOGIQUE DE SOYE")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("56270 PLOEMEUR")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:contact@accelarge.com") {
            org.jetbrains.compose.web.dom.Text("contact@accelarge.com")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("SIRET : 988825956 00010 - RCS de LORIENT")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("Directeur de publication : DANIEAU Pierre")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Le site est hébergé par :")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("1&1 IONOS SARL")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("7 place de la Gare")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("57200 Sarreguemines")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:info@ionos.fr") {
            org.jetbrains.compose.web.dom.Text("info@ionos.fr")
        }
        org.jetbrains.compose.web.dom.Br()
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.ionos.fr/") {
            org.jetbrains.compose.web.dom.Text("https://www.ionos.fr/")
        }
    }
}
